import React from 'react';
import { Globe2, ChevronDown, ShieldCheck, ArrowRightLeft, FileText } from 'lucide-react';
import Logo from '../Logo';
import { useSite } from '../../context/SiteContext';

const DEFAULT_HEADLINE = 'Savings for your customers. Control for your team.';
const OLD_DESCRIPTION = 'Your team deposits, lends and prints receipts. Your customers check balances, transfer and download statements.';
const BENEFITS = [{ id: 'security', Icon: ShieldCheck }, { id: 'transfers', Icon: ArrowRightLeft }, { id: 'statements', Icon: FileText }];

export const LoginHeader = ({ language: { text, locale, changeLocale, allowSelection } }) => (
  <header className="login-header">
    <div className="login-brand">
      <Logo size="xl" showText={false} dark testId="login-desktop-logo" />
      <p data-testid="login-brand-tagline">{text.brandTagline}</p>
    </div>
    {allowSelection && <div className="login-language">
      <Globe2 aria-hidden="true" size={25} />
      <select aria-label={text.languageLabel} data-testid="login-language-select" value={locale} onChange={e => changeLocale(e.target.value)}>
        <option value="en" data-testid="login-language-en">English</option><option value="so" data-testid="login-language-so">Soomaali</option><option value="de" data-testid="login-language-de">Deutsch</option>
      </select>
      <ChevronDown size={17} aria-hidden="true" />
    </div>}
  </header>
);

export const LoginIntroduction = ({ text }) => {
  const { settings } = useSite();
  const frontend = settings?.frontend;
  const defaultHeadline = !frontend?.headline || frontend.headline === DEFAULT_HEADLINE;
  const description = !frontend || frontend.description === OLD_DESCRIPTION ? text.description : frontend.description;
  return <section className="login-introduction" aria-labelledby="login-headline">
    <h1 id="login-headline" data-testid="login-headline" className="login-headline">
      {defaultHeadline ? <>{text.headline}<span>{text.headlineAccent}</span></> : frontend.headline}
    </h1>
    <p data-testid="login-description" className="login-description">{description}</p>
    {frontend?.showHighlights !== false && <ul className="login-benefits" data-testid="login-benefits">
      {BENEFITS.map(({ id, Icon }, index) => <li key={id} data-testid={`login-benefit-${index}`}>
        <span className="login-benefit-icon"><Icon aria-hidden="true" strokeWidth={1.4} /></span>
        <div><h3>{text.highlights[index].title}</h3><p>{text.highlights[index].description}</p></div>
      </li>)}
    </ul>}
    <p className="login-values" data-testid="login-values"><span aria-hidden="true" />{text.values}</p>
  </section>;
};